// @flow
import React from 'react';


type Props = {
  data: any,
};

function ComponentLoader(props: Props){
  const {data} = props;
  return data === null 
    ? (<div>Loading...</div>)
    : null;
}

export default ComponentLoader;



// WEBPACK FOOTER //
// ./src/components/ComponentLoader/ComponentLoader.js